import * as Yup from 'yup';

const schema = Yup.object().shape({
  Name: Yup.string().required('O campo deve ser preenchido'),
  Description: Yup.string().required('O campo deve ser preenchido'),
})

export default schema;